<script lang="ts">
    import { DEFAULT_BOX, DEFAULT_LAYOUT } from '$lib/components/constants';

    import { cn } from '$lib/utils/cn';

    import { flatten } from 'lottie-colorify';
    import { onMount } from 'svelte';

    import { getBoxAttributes } from '../_utils/getBoxAttributes';
    import { getFixedAnimateLottie } from '../_utils/getFixedAnimateLottie';
    import Box from '../_wrappers/Box.svelte';
    import Text from '../Text/Text.View.svelte';

    import type { LoaderSize } from '$lib/types/Components/Loader/LoaderContent';
    import type { Box as BoxType } from '$lib/types/Components/SharedTypes';

    export let id = '';
    export let box: BoxType;
    export let wysiwygHtml: string | undefined = undefined;
    export let size: LoaderSize = 'medium';
    export let iconJsonUrl: string;
    export let color: string;
    export let layout = DEFAULT_LAYOUT;
    export let textColor: string;
    export let autoplay = true;

    let lottieJson: string | null = null;

    onMount(async () => {
        if (iconJsonUrl) {
            await import('@lottiefiles/lottie-player');

            try {
                const response = await fetch(iconJsonUrl);
                const json = await response.json();

                lottieJson = flatten(color, getFixedAnimateLottie(json));
            } catch (err) {
                console.warn('Error fetching Lottie JSON', {
                    iconJsonUrl,
                    error: err,
                });
            }
        }
    });

    const wrapperClasses = cn({
        'fun-size-8 sm:fun-size-12': size === 'small',
        'fun-size-[77px] sm:fun-size-[120px]': size === 'medium',
        'fun-size-[155px] sm:fun-size-[240px]': size === 'large',
    });

    const textSpacingClasses = cn({
        'fun-mt-3': size === 'small',
        'fun-mt-4': size === 'medium',
        'fun-mt-6': size === 'large',
    });
</script>

<Box {id} {...getBoxAttributes({ box, isInColumn: layout.isInColumn })}>
    <div class="fun-flex fun-flex-col fun-items-center fun-justify-center">
        <div class={wrapperClasses}>
            {#if lottieJson}
                <lottie-player src={lottieJson} loop {autoplay} />
            {/if}
        </div>

        <div class={cn('fun-text-center', textSpacingClasses)}>
            <Text
                {wysiwygHtml}
                align="center"
                color={textColor}
                box={DEFAULT_BOX}
                transitionEffect="none"
            />
        </div>
    </div>
</Box>
